import { Bot, Palette, Smartphone, Gauge, Search, HeartHandshake } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WHY_ME } from "../config/site";

const ICONS = [Bot, Palette, Smartphone, Gauge, Search, HeartHandshake];

export default function WhyMe() {
  return (
    <section
      id="why"
      className="relative scroll-mt-24 py-24 sm:py-28"
      data-testid="why-section"
    >
      <div
        className="pointer-events-none absolute right-1/4 top-0 h-[380px] w-[560px] rounded-full bg-purple-600/[0.07] blur-[120px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          center
          eyebrow="Why Choose Me"
          title={
            <>
              Built Different, <span className="text-gradient">Built with AI</span>
            </>
          }
          sub="Everything about my process is designed to give your business a premium online presence — quickly and reliably."
        />

        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_ME.map((w, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={w.title} delay={0.06 * (i % 3)} className="h-full">
                <div
                  className="glass card-hover group flex h-full items-start gap-4 rounded-2xl p-6"
                  data-testid={`why-card-${i + 1}`}
                >
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-purple-400/25 bg-gradient-to-br from-purple-500/20 to-indigo-500/10 text-purple-300 transition-all duration-500 group-hover:shadow-[0_0_20px_rgba(168,85,247,0.4)]">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="font-display text-base font-bold text-white">
                      {w.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-slate-400">
                      {w.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
